import { Button } from "../button/button";
import React, { useRef } from "react";
import styles from "./single-file-upload.module.scss";
import { CircularProgress } from "../circular-progress/circular-progress";

interface ISingleFileUploadProps {
    className: string;
    display?: "button" | "div";
    text: string;
    view?: "legal";
    accept?: string;
    onFileChange: (file: File) => void;
    loading?: boolean;
}

export const SingleFileUpload: React.FC<ISingleFileUploadProps> = React.memo(({
                                                                                  className,
                                                                                  onFileChange,
                                                                                  text,
                                                                                  accept,
                                                                                  display = "button",
                                                                                  loading = false,
                                                                                  view
                                                                              }) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            onFileChange(e.target.files[0]);
            e.target.value = "";
        }
    };

    const onHandleFileInput = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    return (
        <div className={className}>
            {display === "button" && <Button className={styles.button} onClick={onHandleFileInput} view={view}>
                <div className={styles.buttonInnerContainer}>
                    {text}
                    {loading && <CircularProgress size={15} className={styles.loader}/>}
                </div>
            </Button>}
            {display === "div" && <div onClick={onHandleFileInput}>
                {text}
            </div>}
            <div className={styles.inputGroup}>
                <input id="file" type="file" accept={accept} onChange={handleFileChange} ref={inputRef}/>
            </div>
        </div>
    );
});
